export const TOKEN_MIN_VALID_TIME = 10

export const TOKENS_TYPES = {
  REFRESH_TOKEN: 'refresh_token',
  ACCESS_TOKEN: 'token',
  ID_TOKEN: 'id_token',
  CLIENT_ID: 'clientId',
}
